export default {
  contracts: {
    activeContracts: 'Активни договори',
    productsAndHours: 'Продукти с подръжка и оставащи часове подръжка',
    supported: 'С подръжка',
    notSupported: 'Без подръжка',
    contact: 'Мениджър'
  },
  states: {
    OPEN: 'Отворен',
    AWAITING_REPLY: 'Очаква се отговор',
    CLOSED: 'Затворен',
    FEEDBACK_REQUIRED: 'Изисква се обратна връзка',
    onlyRequired: 'Показва само изисканото действие',
    onlyWorkRequests: 'Показване само на одобрение на работни заявки'
  },
  common: {
    New: 'Нов',
    Open: 'Отворен',
    Pending: 'В очакване',
    Closed: 'Затворен',
    create: 'Създай',
    cancel: 'Отказ',
    goBack: 'Връщане',
    close: 'Затвори',
    goToMain: 'Отиди първа страница'
  },
  property: {
    name: 'Обект',
    allProperties: 'Всички обекти',
    selectProperty: 'Избери обекти'
  },
  product: {
    name: 'Продукт',
    allProducts: 'Всички продукти',
    selectProduct: 'Избери продукт',
    goBack: 'Връщане',
    noProducts: 'Без продукт'
  },
  chart: {
    chooseMonth: 'Избери месец',
    noData: 'Няма данни за избрания период'
  },
  navigation: {
    main: 'ОСНОВЕН',
    interactions: 'ЗАЯВКИ',
    contracts: 'ДОГОВОРИ',
    signOut: 'ИЗХОД'
  },
  tickets: {
    createNewTitle: 'Създай нова заявка',
    title: 'Заглавие',
    noTickets: 'Няма заявки с избрания филтър',
    search: 'Търси',
    createNew: 'Създай нов',
    reopenOrDisagree: 'Не съм съгласен',
    escalation: 'Ескалиране',
    reason: 'Причина',
    reopen: 'Не съм съгласен',
    escalate: 'Ескалиране',
    opinionTitle: 'Вашето мнение е важно за нас!',
    opinionBody: 'Моля, оценете работата на нашата подръжка',
    time: 'Време решение',
    qualification: 'Техническа квалификация',
    communication: 'Умения за общуване',
    sendFeedback: 'Изпрати обратна връзка',
    leaveFeedback: 'Остави обратна връзка',
    close: 'Затвори',
    alreadyHasFeedback: 'Зявката вече има обратна връзка',
    feedbackHasBeenSent: 'Обратната връзка е изпратена',
    ticketHasBeenReopened: 'Заявката е преотворена',
    ticketHasBeenEscalated: 'Заявката е ескалирана',
    comment: 'Коментар',
    approve: 'Одобряване',
    reject: 'Отхвърляне',
    workRequestOnContractNotification:
      'Уважаеми {{fullName}},\n\nВ момента имате {{hoursInSupportContract}} часа услуги с добавена стойност, включени в договора ви за поддръжка.\nЗа изпълнението на билета {{workRequestId}} ще са необходими {{hoursRequested}} часа. \n\nМоля, одобрете приспадането на часовете от баланса за горната задача.\nБлагодарим ви\n\nПоздрави,\n{{author}}',
    workRequestChargeableNotification:
      'Уважаеми {{fullName}},\n\nТази работа не е включена в услугата, нито е гарантирана съгласно договора. Ще се радваме да насрочим и помогнем. Очакваме {{hoursRequested}} часа за изпълнение на заявката {{workRequestId}}.\n\nЦената за изпълнение на тази заявка ще бъде {{amount}}.\nТази оферта е валидна в рамките на 7 дни от датата на издаване. \nАко действително изразходваното време надвишава първоначалната оферта, допълнителен формуляр за заявка за допълнителни часове ще бъде изпратен на заявителя за одобрение. Ако очакваното време е по-малко от първоначалната оферта, първоначалната оферта ще бъде анулирана и коригирана оферта ще бъде да бъдат изпратени.\n\nМоля, одобрете допълнителната работа и таксувайте.\n\nПоздрави,\n{{author}}',
    workRequestCommentRequired:
      'Моля, посочете причина за отказ на заявка за работа'
  },
  severity: {
    name: 'Приоритет',
    0: 'Нормално',
    1: 'Висок',
    2: 'Критично'
  },
  forms: {
    password: 'Парола',
    confirmPassword: 'Потвърди парола',
    passwordsDoNotMatch: 'Паролата не съвпада',
    updatePassword: 'Обнови парола',
    askRestore: 'Запитване за обновяване',
    remember: 'Запомни ме',
    restorePassword: 'Възстановяване парола',
    signIn: 'Вход'
  },
  transactions: {
    date: 'Дата',
    type: 'Тип',
    comment: 'Коментар',
    status: 'Статус',
    subject: 'Заявка за работа',
    name: 'Списък транзакции',
    hours: 'Часове',
    viewTransactions: 'Виж трансакциите',
    types: {
      WORK_REQUEST: 'Заявка за работа',
      CONTRACT_ACTIVATION: 'Активация договор',
      CONTRACT_EXPIRATION: 'Изтичане на договор',
      MANUAL_ADJUST_ADD: 'Ръчна настройка - добавяне',
      MANUAL_ADJUST_DEDUCT: 'Ръчна настройка - изваждане',
      TRANSFER_PROPERTY: 'Прехвърляне на обект',
      TRANSFER_PRODUCT: 'Прехвърляне на продукт'
    }
  },
  transactionDetail: {
    name: 'Детайли транзакция',
    num: 'Номер',
    insertTime: 'Дата създаване',
    requestorName: 'Име заявител',
    subject: 'Тема',
    status: 'Статус',
    acceptTime: 'Дата приемане',
    cancelTime: 'Дата на отказ',
    hours: 'Часове',
    hourType: 'Тип часове',
    workText: 'Описание на работата',
    plannedDate: 'Дата планиране'
  },
  statuses: {
    Approved: 'Одобрен',
    Pending: 'В очакване',
    Cancelled: 'Отказан'
  },
  hoursTypes: {
    'Included in contract': 'Включен в договора',
    'Installation hours': 'Часове за инсталация',
    'Preventative visit': 'Превантивно посещение',
    Chargeable: 'Подлежи на плащане'
  },
  errors: {
    unknown: 'Неизвестна грешка',
    1000: 'Грешка в заявката',
    1001: 'Грешка в заявката',
    1: 'Грешно име или парола',
    2: 'Сесията е изтекла',
    3: 'Неизвестен обект',
    4: 'Неизвестен продукт',
    7: 'Неизестно действие',
    8: 'Действието е вече затворено',
    11: 'Нарушаване на достъпа',
    12: 'Неизвестна заявка за работа'
  }
}
